/* eslint-disable import/prefer-default-export */

/**
 * Timestamp to date conversion.
 *
 * @example
 *  formatTimestamp() => '...' (can be used as skeleton placeholder)
 *  formatTimestamp(0) => '01.01.1970'
 *  formatTimestamp(1592230569899) => '15.06.2020'
 */
export const formatTimestamp = (timestamp?: number): string =>
  typeof timestamp === 'undefined'
    ? '...'
    : new Date(timestamp).toLocaleString(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

/**
 * Convert a comma separated string to a lowercase sorted unique array without
 * whitespaces.
 *
 * @example
 *  csvToTagList('') => []
 *  csvToTagList('test') => ['test']
 *  csvToTagList('test, tag, 123') => ['123', 'tag', 'test']
 *  csvToTagList('test, tag, 123', 'test') => ['123', 'tag', 'test']
 *  csvToTagList('test dies das ananas') => ['testdiesdasananas']
 */
export const csvToTagList = (str: string): string[] => [
  ...new Set(
    (str || '')
      .toLowerCase()
      .replace(/[^\w,]+/g, '')
      .split(/,\s?/)
      .filter(Boolean)
      .sort()
  ),
];
